<div class="notification-overlay" [class.open]="open">

	<button type="button" class="notification-backdrop" (click)="close()" aria-label="Close notifications"></button>

	<aside class="notification-panel" role="dialog" aria-modal="true" aria-labelledby="notif-title">

		<div class="px-3 pt-3 pb-2 border-bottom bg-white">
			<div class="d-flex align-items-start justify-content-between mb-3">
				<div>
					<h2 id="notif-title" class="fw-bold mb-1" style="font-size:24px;color:#0f172a;">Notifications</h2>
					<p class="mb-0 text-muted" style="font-size:13px;">
						{{ notifications.length }} total &bull; {{ unreadCount }} unread
					</p>
				</div>
				<button type="button"
					class="notif-close-btn btn border-0 rounded-circle d-flex align-items-center justify-content-center"
					(click)="close()" aria-label="Close">
					<i class="fa-solid fa-xmark"></i>
				</button>
			</div>

			<div class="d-flex gap-2 p-1 rounded-3" style="background:#f1f5f9;">

				<button type="button"
					class="notif-tab btn btn-sm flex-fill rounded-2 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1"
					[class.active]="activeTab === 'all'" (click)="setTab('all')">
					All
					<span class="notif-tab-badge" [class.notif-tab-badge--active]="activeTab === 'all'">
						{{ notifications.length }}
					</span>
				</button>

				<button type="button"
					class="notif-tab btn btn-sm flex-fill rounded-2 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1"
					[class.active]="activeTab === 'read'" (click)="setTab('read')">
					Read
					<span class="notif-tab-badge" [class.notif-tab-badge--active]="activeTab === 'read'">
						{{ readCount }}
					</span>
				</button>

				<button type="button"
					class="notif-tab btn btn-sm flex-fill rounded-2 fw-semibold border-0 d-flex align-items-center justify-content-center gap-1 position-relative"
					[class.active]="activeTab === 'unread'" (click)="setTab('unread')">
					Unread
					<span class="notif-tab-badge notif-tab-badge--unread"
						[class.notif-tab-badge--active]="activeTab === 'unread'">
						{{ unreadCount }}
					</span>
				</button>

			</div>
		</div>

		<div class="px-3 py-2 border-bottom bg-white d-flex align-items-center gap-2">
			<div class="position-relative grow">
				<i class="fa-solid fa-magnifying-glass position-absolute top-50 translate-middle-y text-secondary"
					style="left:10px;font-size:13px;"></i>
				<input type="text" #searchInput class="form-control form-control-sm rounded-3 ps-4 border-0"
					style="background:#f8fafc;" placeholder="Search notifications..."
					(input)="onSearch(searchInput.value)" />
			</div>
		</div>

		<div class="notif-content p-3" (scroll)="loadMore($event)">

			<div *ngIf="filteredNotifications.length === 0"
				class="d-flex flex-column align-items-center justify-content-center text-center py-5"
				style="min-height:260px;">
				<div class="notif-empty-icon rounded-3 d-flex align-items-center justify-content-center mb-3">
					<i class="fa-regular fa-bell-slash fs-4"></i>
				</div>
				<h5 class="fw-bold mb-1" style="color:#0f172a;">No notifications yet</h5>
				<p class="text-muted mb-0" style="font-size:13px;max-width:230px;">
					New alerts will appear here as soon as they arrive.
				</p>
			</div>

			<section class="mb-4" *ngIf="todayNotifications.length > 0">
				<div class="notif-section-label mb-2 px-1">Today</div>
				<div class="d-flex flex-column gap-2">
					<div class="notif-item bg-white border rounded-3 p-3 position-relative"
						*ngFor="let notif of todayNotifications; trackBy: trackByNotificationId"
						[class.notif-unread]="!notif.isRead" (click)="markAsRead(notif, $event)">
						<div class="d-flex gap-3">
							<div class="notif-icon shrink-0 rounded-3 d-flex align-items-center justify-content-center text-white"
								[ngClass]="getIconTone(notif)">
								<i class="fa-solid" [ngClass]="getIconClass(notif)"></i>
							</div>
							<div class="grow overflow-hidden">
								<div class="d-flex align-items-start justify-content-between gap-2 mb-1">
									<span class="fw-bold text-truncate"
										style="font-size:14px;color:#0f172a;max-width:190px;">{{ notif.title }}</span>
									<span class="text-muted fw-semibold shrink-0" style="font-size:11px;">{{
										formattedDateTime(notif) }}</span>
								</div>
								<p class="notif-item-msg mb-0">{{ notif.message }}</p>
							</div>
						</div>
						<span *ngIf="!notif.isRead" class="notif-unread-dot position-absolute"></span>
					</div>
				</div>
			</section>

			<section class="mb-2" *ngIf="olderNotifications.length > 0">
				<div class="notif-section-label mb-2 px-1">Older</div>
				<div class="d-flex flex-column gap-2">
					<div class="notif-item bg-white border rounded-3 p-3 position-relative"
						*ngFor="let notif of olderNotifications; trackBy: trackByNotificationId"
						[class.notif-unread]="!notif.isRead" (click)="markAsRead(notif, $event)">
						<div class="d-flex gap-3">
							<div class="notif-icon shrink-0 rounded-3 d-flex align-items-center justify-content-center text-white"
								[ngClass]="getIconTone(notif)">
								<i class="fa-solid" [ngClass]="getIconClass(notif)"></i>
							</div>
							<div class="grow overflow-hidden">
								<div class="d-flex align-items-start justify-content-between gap-2 mb-1">
									<span class="fw-bold text-truncate"
										style="font-size:14px;color:#0f172a;max-width:190px;">{{ notif.title }}</span>
									<span class="text-muted fw-semibold shrink-0" style="font-size:11px;">{{
										formattedDateTime(notif) }}</span>
								</div>
								<p class="notif-item-msg mb-0">{{ notif.message }}</p>
							</div>
						</div>
						<span *ngIf="!notif.isRead" class="notif-unread-dot position-absolute"></span>
					</div>
				</div>
			</section>
		</div>
	</aside>
</div>